@if (product$ | async; as product) {
  <article class="container section-outset-b topbar-padding-top">
    <app-breadcrumbs [breadcrumbs]="breadcrumbs" class="my-3 d-block"></app-breadcrumbs>
    <app-json-ld [json]="breadcrumbScheme"></app-json-ld>
    @if (product) {
      <div class="row">
        <figure
          class="col-md-6 product__figure"
          [class.set--slider]="(product?.images?.length || 0) > 1"
          [class.is--sold-out]="!product?.availableForSale"
        >
          <!--<app-product-image-slider
          *ngIf="(product?.images?.length || 0) > 1"
          [hasLink]="false"
          [product]="product"
          [showPagination]="true"
          [showVariantImages]="true"
          [loaded]="detailLoaded"
          [activeProductImageId]="getInitialActiveProductImageId(product)"
          [activeVariantColor]="selectedOptions['Color'] || initialOptions?.['Color']"
        ></app-product-image-slider>-->
          <!--[loaded]="detailLoaded"-->
          @if (product.images || product.media) {
            <app-product-image-slider
              [product]="product"
              [showPagination]="true"
              [hasLink]="false"
              [selectedVariant]="selectedVariant$ | async"
              [showVideos]="true"
              [sizes]="{ md: 6 }"
              [showVariantImages]="true"
            ></app-product-image-slider>
          }
          <!--<img
        *ngIf="product?.images?.length === 1"
        class="product-image product-image-ratio"
        [src]="product?.images?.[0]?.url"
        [alt]="product?.images?.[0]?.altText"
        />
      <img
        *ngIf="product?.images?.length === 0"
        class="product-image product-image-ratio"
        [src]="'product-placeholder-afbeelding' | fromDictionary"
        alt="Placeholder afbeelding"
        />-->
        </figure>
        <main class="my-4 col-md-6 my-mb-0">
          <header class="mb-4">
            <h1 class="gap-3 mb-2 d-flex">
              {{ product.title }}
              <!-- <span class="chip-label type-body-sm text-uppercase chip-filled--danger" *ngIf="!product?.availableForSale">
            {{ 'product-tegel-uitverkocht-label' | fromDictionary }}
          </span> -->
            </h1>
            <em class="d-block fw-semi">
              @if (product?.productType) {
                <span>{{ product?.productType }}</span>
              }
              @if (getUnit(product)) {
                <span class="d-inline-block text-primary">
                  @if (product?.productType) {
                    <span class="d-inline-block ms-1">-</span>
                  }
                  <span class="d-inline-block" [class.ms-1]="product?.productType">{{ getUnit(product, selectedVariant$ | async) }}</span>
                </span>
              }
              <!-- Text with why its not available -->
              @if (isAvailable$ | async; as isAvailable) {
                <span [ngClass]="!(selectedVariant$ | async)?.availableForSale ? 'text-danger' : 'text-muted'">
                  @if (
                    isAvailable.code !== 'AVAILABLE' &&
                    (selectedVariant$ | async) &&
                    (!product.availableForSale || (!(selectedVariant$ | async)?.availableForSale && product.availableForSale))
                  ) {
                    <span class="mx-1 d-inline-block">-</span>
                  }
                  @if (isAvailable.code !== 'AVAILABLE' && (selectedVariant$ | async)) {
                    <span class="d-inline-block text-lowercase">
                      @if (!product.availableForSale) {
                        {{ getLabel('product-status-', isAvailable.code, isAvailable.message) }}
                      }
                      @if (!(selectedVariant$ | async)?.availableForSale && product.availableForSale) {
                        {{ 'variant-niet-beschikbaar-tekst' | fromDictionary }}
                      }
                    </span>
                  }
                </span>
              }
            </em>
            @if ((selectedVariant$ | async)?.price || product?.priceRange?.minVariantPrice; as minPrice) {
              <div class="mt-2 mb-0 h3 d-inline-block">
                @if ((selectedVariant$ | async)?.compareAtPrice || product?.compareAtPriceRange?.minVariantPrice; as comparePrice) {
                  @if (+comparePrice.amount > +minPrice.amount) {
                    <div class="d-inline-flex align-items-center">
                      <del class="price--old type-body-sm product-detail__price-old">
                        {{ comparePrice.amount | currency: comparePrice.currencyCode }}
                      </del>
                      <strong class="price--new">{{ minPrice?.amount | currency: minPrice.currencyCode }}</strong>
                    </div>
                  } @else {
                    {{ minPrice?.amount | currency: minPrice.currencyCode }}
                  }
                } @else {
                  {{ minPrice?.amount | currency: minPrice.currencyCode }}
                }
              </div>
            }
            <!--
      <strong class="mt-2 mb-0 h3 d-inline-block" *ngIf="selectedVariant?.price || product?.priceRange?.minVariantPrice as minPrice">
        <ng-container *ngIf="selectedVariant?.compareAtPrice || product.compareAtPriceRange.minVariantPrice as comparePrice">
          <del *ngIf="comparePrice.amount > minPrice.amount">
            {{ comparePrice.amount | currency: comparePrice.currencyCode }}
          </del>
        </ng-container>
        {{ minPrice?.amount | currency: minPrice.currencyCode }}
      </strong> -->
          </header>
          @if (variantOptionsLeft$ | async; as variantOptionsLeft) {
            <div class="mt-4">
              @if (productColors$ | async; as products) {
                @if (products?.length) {
                  <app-product-swatch-list class="mb-4 d-block" [activeProduct]="product" [products]="products"></app-product-swatch-list>
                }
              }
              @if ((product?.variants?.length || 0) > 1 && (product?.options?.length || 0) > 0) {
                <div class="mb-4">
                  @for (option of product?.options; track option) {
                    @if (isColorVariant(option.name)) {
                      <app-variant-swatch-list
                        [option]="option"
                        [product]="product"
                        [selectedOptionsFromParams]="(routerState$ | async)?.state?.queryParams"
                      ></app-variant-swatch-list>
                    }
                    @if (!isColorVariant(option.name)) {
                      <app-product-variant-options
                        [variants]="product.variants || []"
                        [option]="option"
                        [product]="product"
                        [selectedOptionsFromParams]="(routerState$ | async)?.state?.queryParams"
                      ></app-product-variant-options>
                    }
                    <!--<pre>{{ option | json }}</pre>-->
                  }
                </div>
              }
              <app-product-amount
                class="mb-4 d-block"
                [suffix]="getUnit(product) ?? ''"
                [max]="(maxAmount$ | async) ?? 0"
                (getSelectedAmount)="amount = $event"
              ></app-product-amount>
              @if (isAvailable$ | async; as isAvailable) {
                <footer class="button-group product-detail__actions">
                  <!-- add to cart button -->
                  @if ((soldOut$ | async) === false) {
                    <button
                      class="button button--secondary mobile-w-100"
                      [disabled]="isAvailable.code !== 'AVAILABLE'"
                      (click)="orderVariant()"
                      [attr.title]="getLabel('product-status-', isAvailable.code, isAvailable.message)"
                    >
                      <span>{{ 'product-status-AVAILABLE' | fromDictionary }}</span>
                      @if (cartLoading$ | async) {
                        <app-icon class="anim--spinning ms-2 icon-sm" anchor="icon-loader"></app-icon>
                      }
                    </button>
                  }
                  <!-- Sold out message -->
                  @if (soldOut$ | async) {
                    <div class="w-100">
                      @if ((activeStorefront$ | async)?.id === 2) {
                        <p class="text-danger fs-body-xs text-max-width-xs">
                          {{ 'product-detail-uitverkocht-melding' | fromDictionary }}
                        </p>
                        <button class="button button--secondary" disabled="disabled">
                          <app-icon class="icon-sm" anchor="line-icon-mail"></app-icon>
                          <span>{{ 'product-detail-uitverkocht-knoptekst' | fromDictionary }}</span>
                        </button>
                      }
                      @if ((activeStorefront$ | async)?.id !== 2) {
                        <p class="text-danger fs-body-xs text-max-width-xs">
                          {{ 'product-detail-uitverkocht-melding-houdt-me-op-de-hoogte' | fromDictionary }}
                        </p>
                        @if ((klaviyoIsSubScribedBackInStock$ | async) !== true) {
                          <button class="button button--secondary" (click)="notifyMe()">
                            <app-icon class="icon-sm" anchor="line-icon-mail"></app-icon>
                            <span>{{ 'product-detail-uitverkocht-melding-houdt-me-op-de-hoogte-knoptekst' | fromDictionary }}</span>
                          </button>
                        }
                        @if (klaviyoIsSubScribedBackInStock$ | async) {
                          <span class="button button--success button-outline button-outline--no-hover">
                            <app-icon class="chip chip--success icon-xs" anchor="icon-check"></app-icon>
                            <span>{{ 'product-detail-uitverkocht-melding-houdt-me-op-de-hoogte-gelukt' | fromDictionary }}</span>
                          </span>
                        }
                      }
                    </div>
                  }
                  <!-- Download pattern -->
                  @if (product.metafield) {
                    @if (product.metafield.key === 'patern_file') {
                      <div class="product-pattern-wrapper">
                        <a [href]="product.metafield.reference.url" target="_blank" class="button button-outline button--secondary me-3">
                          <span>{{ 'product-patroon-button-tekst' | fromDictionary }}</span>
                        </a>
                        <app-icon [anchor]="'icon-info'" (click)="tooltip.toggle()"></app-icon>
                        <span
                          #tooltip="matTooltip"
                          class="product-pattern-wrapper__info"
                          matTooltipClass="type--info"
                          [matTooltip]="'product-patroon-tooltip-tekst' | fromDictionary"
                          matTooltipPosition="below"
                        ></span>
                      </div>
                    }
                  }
                </footer>
              }
              @if (listSpecifications(product); as specs) {
                @if (specs.length) {
                  <hr class="my-4" />
                }
                @if (specs.length) {
                  <app-product-specifications [specs]="specs"></app-product-specifications>
                }
              }
              @if (product?.descriptionHtml || '' | stripHtml) {
                <div class="mt-4-5">
                  <h2 class="mb-1 h5">{{ 'product-omschrijving-titel' | fromDictionary }}</h2>
                  <div class="markdown-content type-body-sm" [innerHTML]="product.descriptionHtml"></div>
                </div>
              }

              @if (complementaryProducts().length) {
                <section class="related-products pt-3 mt-4 border-top">
                  <span class="h3 mb-4 d-inline-block">{{ 'product-complementary-titel' | fromDictionary }}</span>
                  <ul class="row product-list gutter-x-3">
                    @for (item of complementaryProducts() | slice: 0 : 3; track item; let i = $index) {
                      <li class="col-6 col-md-4" [ngClass]="i > 1 ? 'd-none d-md-block' : ''">
                        <app-product-card
                          [product]="item"
                          [showSlider]="true"
                          [sizes]="{ xs: 6, md: 2, lg: 1 }"
                          [compact]="true"
                        ></app-product-card>
                      </li>
                    }
                  </ul>
                </section>
              }
            </div>
          }
        </main>
      </div>
    }

    @for (gallery of imageMapSliders.value(); track gallery.id) {
      <!-- @let galleryt = {...gallery, imageMaps: gallery.imageMaps.slice(0, 1)}; -->

      <section class="section-outset-y mt-2-5">
        <h2 class="h1">{{ gallery.title || ('product-shop-de-look-fallback-titel' | fromDictionary) }}</h2>
        <app-product-gallery [productGallery]="gallery"></app-product-gallery>
      </section>
    }

    <!-- <pre>{{ imageMapSliders.value() | json }}</pre> -->

    @if (recommendations$ | async; as relatedProducts) {
      @if (relatedProducts.length) {
        <section class="related-products section-outset-y mt-2-5">
          <h1>{{ 'product-gerelateerd-titel' | fromDictionary }}</h1>
          <ul class="row product-list">
            @for (item of relatedProducts | slice: 0 : 3; track item; let i = $index) {
              <li class="col-6 col-md-4" [ngClass]="i > 1 ? 'd-none d-md-block' : ''">
                <app-product-card [product]="item" [showSlider]="true" [sizes]="{ xs: 6, md: 2, lg: 1 }"></app-product-card>
              </li>
            }
          </ul>
        </section>
      }
    }
    @if (schema) {
      <app-json-ld [json]="schema"></app-json-ld>
    }

    @if (reviewCount() > 0) {
      <section class="section-outset-y mt-2-5">
        <h2 class="h3 mb-2">{{ 'product-reviews-titel' | fromDictionary }}</h2>
        <app-product-reviews [reviews]="reviewsResource.value()!.reviews" />
      </section>
    }
  </article>
}

<!-- <app-json-ld [json]="breadcrumbScheme"></app-json-ld> -->
